import "./NotificationChart.css";

const NotificationChart = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="notification-chart">
        <div className="chart-loading">Loading statistics...</div>
      </div>
    );
  }

  if (!stats || stats.total === 0) {
    return (
      <div className="notification-chart">
        <div className="chart-empty">No data available</div>
      </div>
    );
  }

  const total = stats.read + stats.unread;

  const readPercent = total
    ? Number(((stats.read / total) * 100).toFixed(1))
    : 0;

  const unreadPercent = Number((100 - readPercent).toFixed(1));

  const hasRead = stats.read > 0;
  const hasUnread = stats.unread > 0;

  return (
    <div className="notification-chart">
      <div className="chart-header">
        <h3 className="chart-title">Notification Statistics</h3>
        <div className="chart-total">Total: {stats.total}</div>
      </div>

      <div className="chart-bars">
        {/* READ */}
        <div className="bar-item">
          <div className="bar-info">
            <span className="bar-label">Read</span>
            <span className="bar-value">{stats.read}</span>
          </div>

          <div className="bar-track">
            {hasRead && (
              <div
                className="bar-fill bar-read"
                style={{
                  width: `${readPercent}%`,
                  minWidth: readPercent > 0 ? 8 : 0,
                }}
              >
                {readPercent >= 10 && (
                  <span className="bar-percent">{readPercent}%</span>
                )}
              </div>
            )}

            {!hasRead && <span className="bar-zero">0%</span>}
          </div>
        </div>

        {/* UNREAD */}
        <div className="bar-item">
          <div className="bar-info">
            <span className="bar-label">Unread</span>
            <span className="bar-value">{stats.unread}</span>
          </div>

          <div className="bar-track">
            {hasUnread && (
              <div
                className="bar-fill bar-unread"
                style={{
                  width: `${unreadPercent}%`,
                  minWidth: unreadPercent > 0 ? 8 : 0,
                }}
              >
                {unreadPercent >= 10 && (
                  <span className="bar-percent">{unreadPercent}%</span>
                )}
              </div>
            )}

            {!hasUnread && <span className="bar-zero">0%</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationChart;
